import { render, staticRenderFns } from "./NavigationBarV2.vue?vue&type=template&id=29a406d7&"
import script from "./NavigationBarV2.vue?vue&type=script&lang=js&"
export * from "./NavigationBarV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports